import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignoAuditoriaService } from '@services/auditoria/signo-auditoria.service';
import { InscripcionesAuditoriaService } from '@services/auditoria/inscripciones-auditoria.service';
import { SignoAuditoriaEvento } from '@interfaces/interface-bakend/auditoria/signo-auditoria-evento.interface';
import {
    emailDeEvento,
    iconoAccionInscripcion,
    labelAccionInscripcion,
    nombreDeEvento,
    resumenEvento,
    solicitudDeEvento,
} from '../inscripciones-auditoria.diccionario';

@Component({
    selector: 'app-inscripciones-auditoria-detalle',
    templateUrl: './inscripciones-auditoria-detalle.component.html',
    styleUrls: ['./inscripciones-auditoria-detalle.component.scss'],
})
export class InscripcionesAuditoriaDetalleComponent implements OnInit {

    evento: SignoAuditoriaEvento | null = null;
    timeline: SignoAuditoriaEvento[] = [];
    payloadEntries: Array<{ clave: string; valor: string }> = [];
    flagLoaded: boolean = false;
    duracionTotalMs = 0;
    duracionTotalTexto = '0 ms';

    labelAccionInscripcion = labelAccionInscripcion;
    iconoAccionInscripcion = iconoAccionInscripcion;
    resumenEvento = resumenEvento;
    emailDeEvento = emailDeEvento;
    nombreDeEvento = nombreDeEvento;
    solicitudDeEvento = solicitudDeEvento;

    constructor(
        private router: Router,
        private signoAuditoriaService: SignoAuditoriaService,
        private inscripcionesAuditoria: InscripcionesAuditoriaService,
    ) {}

    async ngOnInit(): Promise<void> {
        if (!(await this.signoAuditoriaService.puedeAccederAuditoria())) {
            this.signoAuditoriaService.setAccesoDenegado(true);
            this.router.navigateByUrl('/configurar-administracion');
            return;
        }

        this.evento = this.signoAuditoriaService.getEventoSeleccionado() || null;
        if (!this.evento) {
            this.router.navigateByUrl('/auditoria-inscripciones');
            return;
        }

        this.payloadEntries = Object.entries(this.evento.payload || {}).map(([clave, valor]) => ({
            clave,
            valor: this.formatValor(valor),
        }));

        await this.cargarTimeline();
        this.calcularDuracionTotal();
        this.flagLoaded = true;
    }

    /** Suma de los tiempos medidos (duracionMs) de los pasos del intento. */
    private calcularDuracionTotal(): void {
        this.duracionTotalMs = this.timeline.reduce((acc, e) => {
            const d = Number((e.payload as any)?.duracionMs);
            return acc + (isFinite(d) ? d : 0);
        }, 0);
        this.duracionTotalTexto = this.formatearDuracion(this.duracionTotalMs);
    }

    private formatearDuracion(ms: number): string {
        if (!ms || ms < 0) {
            return '0 ms';
        }
        if (ms < 1000) {
            return `${Math.round(ms)} ms`;
        }
        const segundos = ms / 1000;
        if (segundos < 60) {
            return `${segundos.toFixed(segundos < 10 ? 2 : 1)} s`;
        }
        const min = Math.floor(segundos / 60);
        const seg = Math.round(segundos % 60);
        return `${min} min ${seg} s`;
    }

    private async cargarTimeline(): Promise<void> {
        const actual = this.evento;
        if (!actual) {
            this.timeline = [];
            return;
        }
        const traceId = actual.traceId;
        if (!traceId) {
            this.timeline = [actual];
            return;
        }
        const eventos = await this.inscripcionesAuditoria.getEventosByTrace(traceId);
        this.timeline = (eventos.length ? eventos : [actual])
            .slice()
            .sort((a, b) => (a.fecha || '').localeCompare(b.fecha || ''));
    }

    private formatValor(valor: any): string {
        if (valor === null || valor === undefined) { return '-'; }
        if (typeof valor === 'boolean') { return valor ? 'Sí' : 'No'; }
        if (typeof valor === 'object') { return JSON.stringify(valor); }
        return `${valor}`;
    }

    volver(): void {
        this.router.navigateByUrl('/auditoria-inscripciones');
    }
}
